import { useTranslation } from "react-i18next";
import type { DealerDeviceTransferNotification } from "@/gql/graphql";
import DataListItemText from "@/components/app/Navigation/GlobalHeader/Notifications/Data/DataListItemText";

type DeviceTransferRequestCancelledNotificationProps = {
  data: Pick<DealerDeviceTransferNotification, "model" | "serialNumber">;
};

const DeviceTransferRequestCancelledNotification = (
  props: DeviceTransferRequestCancelledNotificationProps
) => {
  const { data } = props;
  const { model, serialNumber } = data;
  const { t } = useTranslation();

  return (
    <DataListItemText
      primary={t("notifications.device_transfer_request_cancelled.title")}
      secondary={t(
        "notifications.device_transfer_request_cancelled.description",
        { model: model ?? "", serialNumber }
      )}
    />
  );
};

export default DeviceTransferRequestCancelledNotification;
